import Tooltip, { TooltipPosition } from "@ingka/tooltip";
import Text from "@ingka/text";
import Button from "@ingka/button";
import questionMarkCircle from "@ingka/ssr-icon/paths/question-mark-circle";

type Props = {
  labelText: string;
  toolTipText?: string;
  toolTipPosition?: TooltipPosition;
};

const LabelWithToolTip = ({
  labelText,
  toolTipText,
  toolTipPosition = "top",
}: Props) => {
  return (
    <div className="flex min-h-space250 items-center gap-x-space50">
      <Text tagName="span" bodySize="m">
        {labelText}
      </Text>
      {toolTipText && (
        <Tooltip position={toolTipPosition} tooltipText={toolTipText}>
          <Button
            iconOnly
            size="small"
            ssrIcon={questionMarkCircle}
            type="tertiary"
            aria-label="More information"
          />
        </Tooltip>
      )}
    </div>
  );
};

export default LabelWithToolTip;
